import About from '../components/About';
import Services from '../components/Services';
import Contact from '../components/Contact';
import { Products } from './Products';

function Main() {
  return (
    <>
      <main>
        <Products/>
        <Services />
        <About />
        {/* <Contact /> */}
      </main>
    </>
  );
}
export default Main;
